import React from 'react';

const SECTORS = ['all', 'Real Estate', 'Tech', 'Healthcare', 'Consumer Goods', 'Finance', 'Food & Beverage', 'Fashion', 'Education', 'Other'];
const STAGES = ['all', 'Pre-Seed', 'Seed', 'Series A', 'Series B', 'Growth'];
const STATUSES = ['all', 'pending', 'under_review', 'approved', 'rejected'];

const STATUS_LABELS = { all: 'All Status', pending: 'Pending', under_review: 'Under Review', approved: 'Approved', rejected: 'Rejected' };

export default function FilterBar({ filters, onFilterChange }) {
  return (
    <div className="flex flex-wrap gap-3 mb-5">
      <select
        value={filters?.status}
        onChange={(e) => onFilterChange({ ...filters, status: e?.target?.value })}
        className="px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium outline-none focus:border-[#D4A520] appearance-none bg-white"
        style={{ color: '#0B1F3B' }}
      >
        {STATUSES?.map(s => <option key={s} value={s}>{STATUS_LABELS?.[s]}</option>)}
      </select>
      <select
        value={filters?.sector}
        onChange={(e) => onFilterChange({ ...filters, sector: e?.target?.value })}
        className="px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium outline-none focus:border-[#D4A520] appearance-none bg-white"
        style={{ color: '#0B1F3B' }}
      >
        {SECTORS?.map(s => <option key={s} value={s}>{s === 'all' ? 'All Sectors' : s}</option>)}
      </select>
      <select
        value={filters?.fundingStage}
        onChange={(e) => onFilterChange({ ...filters, fundingStage: e?.target?.value })}
        className="px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium outline-none focus:border-[#D4A520] appearance-none bg-white"
        style={{ color: '#0B1F3B' }}
      >
        {STAGES?.map(s => <option key={s} value={s}>{s === 'all' ? 'All Stages' : s}</option>)}
      </select>
    </div>
  );
}
